import IFilter from "models/IFilter";
import React from "react";

import _ from "lodash";
import DetailView from "components/DetailView";
import { CUSTOM_SETTINGS } from "constants/index";
import Input from "components/Input";
import Button from "components/Button";
import withFilters from "helpers/withFilters";
import FilterGenerator from "helpers/filter";
import YearDropdown from "../../deliveryNotes/partials/YearDropdown";

interface IProps extends IFilter {
  statusOptions: any[];
  typeOptions: any[];
  yearRange: { minYear: number; maxYear: number };
}

class AreaStatementSearch extends React.Component<IProps> {
  public static getInputQuery = (value) => {
    const Q = new FilterGenerator();
    console.log(typeof value);

    Q.and("LicenceContractLine/LicenceContract/Licensor/Name", value);
    if (typeof value === "string") {
      Q.or("LicenceContractLine/LicenceContract/Specie", value);
      Q.or("LicenceContractLine/LicenceContract/Cultivar", value);
    }
    if (!isNaN(Number(value))) {
      Q.or("LicenceContractLine/LicenceContract/Licensor/Number", value);
      Q.or("AreaStatement/HarvestYear", value, "number");
    }

    return Q.query;
  };

  public static getFilterQuery = (f) => {
    const Q = new FilterGenerator();
    if (!_.isEmpty(f.harvestYear)) {
      Q.and("AreaStatement/HarvestYear", f.harvestYear, "numberRange");
    }
    if (!_.isEmpty(f.orderDate)) {
      Q.and("Date", f.orderDate, "dateRange");
    }
    Q.and(
      "LicenceContractLine/LicenceContract/Licensor/Name",
      f.counterpartyName
    );
    Q.and(
      "LicenceContractLine/LicenceContract/Licensor/Number",
      f.counterpartyNumber
    );
    Q.and("LicenceContractLine/LicenceContract/Cultivar", f.cultivar);
    Q.and("LicenceContractLine/LicenceContract/Specie", f.specie);
    Q.and("StateId", f.status, "select");
    Q.and("Bio", f.bio, "boolean");

    return Q.query;
  };

  public maskOnInput = (e) => {
    const { filter, handleFilterChange } = this.props;
    const value = e.target.validity.valid
      ? e.target.value
      : _.get(filter, e.target.name, "");

    handleFilterChange(value, e.target.name);
  };

  public render = () => {
    const {
      filter,
      handleFilterChange,
      generateFilter,
      resetFilter,
      yearRange,
    } = this.props;

    return (
      <DetailView pageName={CUSTOM_SETTINGS.orders}>
        <div className="filter-row">
          <Input
            label="OTHER_PARTY_NAME"
            value={filter.counterpartyName}
            onChange={(e) =>
              handleFilterChange(e.target.value, "counterpartyName")
            }
          />
          <Input
            label="DELIVERIES_GENUS"
            value={filter.specie}
            onChange={(e) => handleFilterChange(e.target.value, "specie")}
          />
        </div>
        <div className="filter-row">
          <Input
            label="COUNTERPARTY_NUMBER"
            value={filter.counterpartyNumber}
            onChange={(e) =>
              handleFilterChange(e.target.value, "counterpartyNumber")
            }
          />
          <Input
            label="DELIVERIES_CULTIVAR"
            onChange={(e) => handleFilterChange(e.target.value, "cultivar")}
            value={filter.cultivar}
          />
        </div>
        <div className="filter-row">
          <YearDropdown
            label="HARVEST_YEAR"
            name="harvestYear"
            range={yearRange}
            value={filter.harvestYear}
            onChange={handleFilterChange}
          />
        </div>
        <div className="search-btn">
          <Button onClick={resetFilter}>RESET</Button>
          <Button kind="primary" onClick={generateFilter}>
            SEARCH
          </Button>
        </div>
      </DetailView>
    );
  };
}

export default withFilters({
  placeholder: "AREA_STATEMENT_SEARCH",
  pageName: CUSTOM_SETTINGS.orders,
})(AreaStatementSearch);
